const TRACKING_PARAM_LANGUAGE = "language"
const TRACKING_PARAM_COUNTRY = "country"
const TRACKING_PARAM_SESSION_ID = "session_id"
const TRACKING_PARAM_REFERRER_SCREEN = "referrer_screen"
const TRACKING_PARAM_SECTIONS_SHOWN = "sections_shown"
const TRACKING_PARAM_SOURCE = "source"
const TRACKING_PARAM_MEDIUM = "medium"
const TRACKING_PARAM_CAMPAIGN = "campaign"

export function getBaseTrackingParams(countryCode, route, referrer, sessionId) {
	return {
		[TRACKING_PARAM_SESSION_ID]: sessionId,
		[TRACKING_PARAM_SECTIONS_SHOWN]: getSections(),
		[TRACKING_PARAM_REFERRER_SCREEN]: referrer,
		[TRACKING_PARAM_LANGUAGE]: getLanguage(route),
		[TRACKING_PARAM_COUNTRY]: countryCode,
		[TRACKING_PARAM_SOURCE]: getQuerystring("utm_source"),
		[TRACKING_PARAM_MEDIUM]: getQuerystring("utm_medium"),
		[TRACKING_PARAM_CAMPAIGN]: getQuerystring("utm_campaign"),
	}
}

const getQuerystring = (querystringKey) => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());

	return params[querystringKey];
}

const getLanguage = (route) => {
	return /\/en\//.test(route) ? "en" : "ar";
}

const getSections = () => {
	let sections = [];
	const elements = Array.from(window.document.querySelectorAll("#sections-links .filter"));

	for (let i = 0; i < elements.length; i++) {
		const sectionId = elements[i].getAttribute("data-id")
		const sectionName = elements[i].innerHTML

		if (!sectionId || parseInt(sectionId, 10) === -1) {
			continue;
		}

		sections.push([ sectionName, sectionId ])
	}

	return sections;
}
